<template>
  <div class="text-center bg-white drop-shadow-md py-4">
    <p class="font-bold text-lg">
      {{ siteName }}
    </p>
    <p class="text-sm">
      {{ siteAddress }}
    </p>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'SiteBanner',

    props: {
      siteAddress: {
        type: String,
        default: '',
      },

      siteName: {
        type: String,
        default: '',
      },
    },
  })
</script>
